import { gql } from "@apollo/client";

const UserProjectsSubscription = gql`
  subscription UserProjectsSubscription($userId: UUID!) {
    listen(topic: "user_project_update") {
      query {
        allUserProjects(
          condition: { userAppId: $userId }
          orderBy: PROJECT_NAME_ASC
        ) {
          nodes {
            id
            projectName
          }
        }
      }
    }
  }
`;

const hash = "d5d626a475848e3734ba4766b2a04dc460963b0530653f81950397658b75b079";

export { UserProjectsSubscription, hash };
